import { useRef, useState } from "react";
import { FormatDateToDDMMYY } from "../../utils/FormatDate"
import HandleUpdateText from "../../utils/HandleUpdateText"
import HandleUpdateSelect from "../../utils/HandleUpdateSelect";
import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from "@mui/material";
import HandleUpdateMultiselector from "../../utils/liveUpdaterHandlers/HandleUpdateMultiselector";
import HandleUpdateCheckbox from "../../utils/HandleUpdateCheckbox";
import Modal from "../ui/Modal";
import { FaEye, FaFacebook, FaLink, FaLinkedin, FaTiktok, FaYoutube } from "react-icons/fa";
import CopyToClipBoard from "../../utils/CopyToClipBoard";
import { ColorSiNo, GetStatusColor, PlanBackgroundColor } from "../../utils/GetTextColor";
import { LinkViewer } from "./LinkViewer";

const ItemRowVentasComercial = ({s, setServices, solutions, user}) => {

  const debounceUpdate = useRef(null); // Referencia para mantener el debouncer

  const ITEM_HEIGHT = 48;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 6.5,
        width: 200,
      },
    },
  };

  const [modalLinks, setModalLinks] = useState(false)

  const colorEstadoAudiovisual = {    
    "No definido": "text-black",
    "Por comenzar": "text-yellow-300",
    "En proceso": "text-blue-500",
    "Terminado con exito": "text-green-500",
    "No finalizado": "text-red-500",
    "Congelado": "text-sky-500",
    "Abandonado": "text-black"
  }

  const colorRevision = {
    "No solicitado al cliente": "text-red-500",
    "Solicitado al cliente": "text-yellow-300",
    "Entregado por el cliente": "text-green-500"
  }
  
  return (
    <tr>

      <Modal
        activeModal={modalLinks}
        onClose={() => setModalLinks(false)}
        centered
        title="Link videos plataformas"
        className="max-w-3xl"
      >
        <div className="max-h-[75vh] overflow-y-auto">
          <div className="flex flex-row items-center gap-3">
            {/* Columna izquierda */}
            <div className="flex flex-col gap-2 w-1/2">
              {/* Youtube */}
              <div className="mb-4 mt-4">
                <label className="text-xs block text-gray-700 mb-2 font-bold">Links Youtube</label>
                <div className="flex flex-col">
                  <label className="text-xs text-gray-700 mb-1">Making Of</label>
                  <LinkViewer icon={FaYoutube} value={s.videoYoutubeMakingOf} />
                  <label className="text-xs text-gray-700 mb-1">Testimonio</label>
                  <LinkViewer icon={FaYoutube} value={s.videoYoutubeTestimonio} />
                  <label className="text-xs text-gray-700 mb-1">Proyecto</label>
                  <LinkViewer icon={FaYoutube} value={s.videoYoutubeProyecto} />
                </div>
              </div>

              {/* Facebook */}
              <div className="mb-4 mt-4">
                <label className="text-xs block text-gray-700 mb-2 font-bold">Links Facebook</label>
                <div className="flex flex-col">
                  <label className="text-xs text-gray-700 mb-1">Making Of</label>
                  <LinkViewer icon={FaFacebook} value={s.videoFacebookMakingOf} />
                  <label className="text-xs text-gray-700 mb-1">Testimonio</label>
                  <LinkViewer icon={FaFacebook} value={s.videoFacebookTestimonio} />
                  <label className="text-xs text-gray-700 mb-1">Proyecto</label>
                  <LinkViewer icon={FaFacebook} value={s.videoFacebookProyecto} />
                </div>
              </div>
            </div>

            {/* Columna derecha */}
            <div className="flex flex-col gap-2 w-1/2">
              {/* Linkedin */}
              <div className="mb-4 mt-4">
                <label className="text-xs block text-gray-700 mb-2 font-bold">Links Linkedin</label>
                <div className="flex flex-col">
                  <label className="text-xs text-gray-700 mb-1">Making Of</label>
                  <LinkViewer icon={FaLinkedin} value={s.videoLinkedinMakingOf} />
                  <label className="text-xs text-gray-700 mb-1">Testimonio</label>
                  <LinkViewer icon={FaLinkedin} value={s.videoLinkedinTestimonio} />
                  <label className="text-xs text-gray-700 mb-1">Proyecto</label>
                  <LinkViewer icon={FaLinkedin} value={s.videoLinkedinProyecto} />
                </div>
              </div>

              {/* Tiktok */}
              <div className="mb-4 mt-4">
                <label className="text-xs block text-gray-700 mb-2 font-bold">Links Tiktok</label>
                <div className="flex flex-col">
                  <label className="text-xs text-gray-700 mb-1">Making Of</label>
                  <LinkViewer icon={FaTiktok} value={s.videoTikTokMakingOf} />
                  <label className="text-xs text-gray-700 mb-1">Testimonio</label>
                  <LinkViewer icon={FaTiktok} value={s.videoTikTokTestimonio} />
                  <label className="text-xs text-gray-700 mb-1">Proyecto</label>
                  <LinkViewer icon={FaTiktok} value={s.videoTikTokProyecto} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <td scope="row" className="sticky z-20 left-0 bg-white px-2 py-2 max-w-[250px] border border-gray-300 truncate text-center font-bold">
        <span className="text-xs truncate">
          {s.cotizacion?.cliente?.nombreComercial}
        </span>
      </td>
      <td scope="row" className={`${GetStatusColor(s.estadoAudiovisual, colorEstadoAudiovisual)} px-2 py-2 max-w-[150px] border border-gray-300 truncate text-center`}>
        <span className="text-xs">
          {s.estadoAudiovisual ? s.estadoAudiovisual : "No definido"}
        </span>
      </td>
      <td scope="row" className="px-2 py-2 max-w-[200px] border border-gray-300 truncate text-center">
        <span className="p-1 text-xs">
          {s.servicio.name}
        </span>
      </td>
      <td scope="row" className="px-2 py-2 max-w-[100px] border border-gray-300 truncate text-center">
        <span className={`${GetStatusColor(s.planServicio.name, PlanBackgroundColor)} text-xs px-2 py-1`}>
          {s.planServicio?.name}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-2 py-2 border border-gray-300 truncate text-center">
        <span className="text-xs">
          {FormatDateToDDMMYY(s.fechaIngreso)}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-2 py-2 border border-gray-300 text-center">
        <span className="text-xs">
          {FormatDateToDDMMYY(s.fechaInicio)}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-1 py-1 border border-gray-300 text-center">
        <span className="text-xs">
          {FormatDateToDDMMYY(s.fechaInfoCompleta)}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-2 py-2 border border-gray-300 text-center">
        <span className="text-xs">
          {FormatDateToDDMMYY(s.fechaFin)}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-2 py-2 border border-gray-300 text-center">
        <span className="text-xs">
          {FormatDateToDDMMYY(s.fechaTermino)}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-2 py-2 border border-gray-300 text-center">
        <span className="text-xs">
          {FormatDateToDDMMYY(s.fechEntrega)}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-2 py-2 border border-gray-300 text-center">
        <span className="text-xs whitespace-nowrap">
          {s.cotizacion.cotizador.name}
        </span>
      </td>
      <td scope="row" className="min-w-[350px] px-2 py-2 border border-gray-300 text-center">
        <input 
          type="text"
          value={s.testimonioClienteVideo}
          placeholder="Link del video"
          className="text-xs w-full text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
          onChange={(e) => HandleUpdateText("testimonioClienteVideo", e.target.value, s.id, "serviciosCotizaciones", debounceUpdate, setServices)}
        />
      </td>
      <td scope="row" className="min-w-[350px] px-2 py-2 border border-gray-300 text-center">
        <select
          value={s.googleMapsReview}
          onChange={(e) => HandleUpdateSelect("googleMapsReview", e.target.value, s.id, "serviciosCotizaciones", setServices)}
          className={`${GetStatusColor(s.googleMapsReview, colorRevision)} text-xs w-full text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent`}
        >
          <option value={"No solicitado al cliente"} className={`${GetStatusColor("No solicitado al cliente", colorRevision)}`}>No solicitado al cliente</option>
          <option value={"Solicitado al cliente"} className={`${GetStatusColor("Solicitado al cliente", colorRevision)}`}>Solicitado al cliente</option>
          <option value={"Entregado por el cliente"} className={`${GetStatusColor("Entregado por el cliente", colorRevision)}`}>Entregado por el cliente</option>
        </select>
      </td>
      <td scope="row" className="min-w-[350px] px-2 py-2 border border-gray-300 text-center">
        <select
          value={s.facebookReview}
          onChange={(e) => HandleUpdateSelect("facebookReview", e.target.value, s.id, "serviciosCotizaciones", setServices)}
          className={`${GetStatusColor(s.facebookReview, colorRevision)} text-xs w-full text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent`}
        >
          <option value={"No solicitado al cliente"} className={`${GetStatusColor("No solicitado al cliente", colorRevision)}`}>No solicitado al cliente</option>
          <option value={"Solicitado al cliente"} className={`${GetStatusColor("Solicitado al cliente", colorRevision)}`}>Solicitado al cliente</option>
          <option value={"Entregado por el cliente"} className={`${GetStatusColor("Entregado por el cliente", colorRevision)}`}>Entregado por el cliente</option>
        </select>
      </td>
      <td scope="row" className="max-w-[150px] px-2 py-2 border border-gray-300 text-center">
        <button 
          className="flex items-center w-full justify-center"
          onClick={() => setModalLinks(true)}
        >
          <div className="p-1.5 text-blue-500 hover:bg-blue-600 hover:bg-opacity-25 rounded-md bg-blue-700 bg-opacity-10">
            <FaEye className="text-xs"/>
          </div>
        </button>
      </td>
      <td scope="row" className="min-w-[100px] px-2 py-2 border border-gray-300 text-center">
        <select
          value={s.serviciosOfrecidos}
          defaultValue={41}
          onChange={(e) => HandleUpdateSelect("serviciosOfrecidos", e.target.value, s.id, "serviciosCotizaciones", setServices)}
          className={`${GetStatusColor(s.serviciosOfrecidos, ColorSiNo)} text-xs w-full text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent`}
        >
          <option value={"No"} className={`${GetStatusColor("No", ColorSiNo)}`}>No</option>
          <option value={"Si"} className={`${GetStatusColor("Si", ColorSiNo)}`}>Si</option>
        </select>
      </td>
      <td scope="row" className="min-w-[350px] px-2 py-2 border border-gray-300 text-center">
        <FormControl sx={{ borderRadius: "8px", height: 32, width: 330, backgroundColor: "white" }}>
          <InputLabel
            sx={{
              fontSize: 12,
              transform: "translate(14px, 6.5px) scale(1)",
              "&.MuiInputLabel-shrink": {
                transform: "translate(14px, -6px) scale(0.75)",
              },
            }}
          >
            Servicios
          </InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            sx={{
              height: 32,
              display: "flex",
              alignItems: "center",
              fontSize: 12,
              borderRadius: "8px",
            }}
            id="demo-multiple-checkbox"
            multiple
            // 🔥 Convertimos los objetos a IDs antes de pasarlo al Select
            value={s.interesServicios?.map((item) => (typeof item === "object" ? item.id : item)) || []}
            onChange={(e) => {
              // 🔥 Filtramos solo IDs antes de enviarlos
              const selectedIds = e.target.value.map((item) => (typeof item === "object" ? item.id : item));
              HandleUpdateMultiselector("interesServicios", selectedIds, s.id, "serviciosCotizaciones", debounceUpdate, setServices);
            }}
            input={<OutlinedInput label="Servicios" sx={{ height: 25, fontSize: 12 }} />}
            renderValue={(selected) =>
              selected
                .map((id) => solutions.find((c) => c.id === id)?.name) // 🔥 Convertimos ID a nombre
                .filter(Boolean)
                .join(", ")
            }
            MenuProps={MenuProps}
          >
            {solutions.map((c, i) => (
              <MenuItem key={i} value={c.id} sx={{ height: "30px" }}>
                <Checkbox checked={s.interesServicios?.some((item) => (typeof item === "object" ? item.id === c.id : item === c.id))} />
                <ListItemText primary={c.name} primaryTypographyProps={{ fontSize: 12, fontFamily: "poppins" }} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </td>
    </tr>
  )
}

export default ItemRowVentasComercial